import axiosInstance from "../utils/axiosInstance";

export const getPatientsApi = async (search) =>
  await axiosInstance.get(`/patient?searchText=${encodeURIComponent(search)}`);
export const getPatientByIdApi = async (patientId) =>
  await axiosInstance.get(`/patient/${patientId}`);
export const approvePatientApi = async (patientId) =>
  await axiosInstance.post(`/patient/approve/${patientId}`);
export const updateMedicalHistoryApi = async ({ patientId, importantMedicalHistory }) =>
  await axiosInstance.patch(`/patient/${patientId}/medical-history`, { importantMedicalHistory });
export const addAllergyApi = async ({ patientId, data }) =>
  await axiosInstance.post(`/patient/${patientId}/allergies`, data);
export const removeAllergyApi = async ({ patientId, allergyId }) =>
  await axiosInstance.delete(`/patient/${patientId}/allergies/${allergyId}`);
export const addConditionApi = async ({ patientId, data }) =>
  await axiosInstance.post(`/patient/${patientId}/conditions`, data);
export const removeConditionApi = async ({ patientId, conditionId }) =>
  await axiosInstance.delete(`/patient/${patientId}/conditions/${conditionId}`);
export const getPatientFilesApi = async ({ patientId, status = "all" }) =>
  await axiosInstance.get(`/patient/${patientId}/files`, { params: { status } });
export const createPatientFilesApi = async ({ patientId, documents, allowDuplicates = false }) =>
  await axiosInstance.post(`/patient/${patientId}/files`, { documents, allowDuplicates });
export const updatePatientFileApi = async ({ patientId, patientFileId, data }) =>
  await axiosInstance.patch(`/patient/${patientId}/files/${patientFileId}`, data);
export const archivePatientFileApi = async ({ patientId, patientFileId }) =>
  await axiosInstance.delete(`/patient/${patientId}/files/${patientFileId}`);
export const restorePatientFileApi = async ({ patientId, patientFileId }) =>
  await axiosInstance.post(`/patient/${patientId}/files/${patientFileId}/restore`);

export const updatePatientApi = async (patientId, type, values) =>
  await axiosInstance.post(`/patient/update/${patientId}?type=${type}`, values);

export const addTreatmentApi = async (patientId, dataToSubmit) =>
  await axiosInstance.post(`/patient/addTreatment/${patientId}`, dataToSubmit);
export const updateTreatmentApi = async (
  patientId,
  treatmentId,
  dataToSubmit
) =>
  await axiosInstance.post(
    `/patient/updateTreatment/${patientId}/${treatmentId}`,
    dataToSubmit
  );
export const removeTreatmentApi = async (patientId, treatmentId) =>
  await axiosInstance.post(
    `/patient/removeTreatment/${patientId}/${treatmentId}`
  );

export const addFluidBalanceApi = async (patientId, dataToSubmit) =>
  await axiosInstance.post(
    `/patient/addFluidBalance/${patientId}`,
    dataToSubmit
  );
export const updateFluidBalanceApi = async (
  patientId,
  fluidBalanceId,
  dataToSubmit
) =>
  await axiosInstance.post(
    `/patient/updateFluidBalance/${patientId}/${fluidBalanceId}`,
    dataToSubmit
  );
export const removeFluidBalanceApi = async (patientId, fluidBalanceId) =>
  await axiosInstance.post(
    `/patient/removeFluidBalance/${patientId}/${fluidBalanceId}`
  );
